import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { translate } from 'react-translate';
import { compose } from 'redux';
import { Button, Form, Grid, Header, Icon, Image, Message, Modal, Segment } from 'semantic-ui-react';
import { addId, addLanguage, addLogin, addRegister, addReset, addToken } from '../../actions/AppActions';
import Exit from '../../assets/img/Exit.svg';
import { onSignIn } from '../../Auth';
import { getFirstPage } from '../../constants/envList';
import JobList from '../Protected/projet/jobList';
import './LoginComponent.css';
import Register from './Register';
import ResetPassword from './ResetPassword';

class LoginComponent extends React.Component {
  static propTypes = {
    addToken: PropTypes.func,
    addId: PropTypes.func,
    addLanguage: PropTypes.func,
    t: PropTypes.func.isRequired,
    app: PropTypes.object,
    addLogin: PropTypes.func,
    addRegister: PropTypes.func,
    addReset: PropTypes.func,
    location: {
      state: PropTypes.string,
    },
    open: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      redirectToReferrer: false,
      email: null,
      password: null,
      error: null,
      error_input_email: true,
      error_input_password: true,
      warningError: null,
    };
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeLogin = this.closeLogin.bind(this);
    this.setRedirect = this.setRedirect.bind(this);
    this.addReset = this.addReset.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.addRegister = this.addRegister.bind(this);
  }

  setToken(token) {
    const { addToken } = this.props;
    addToken(token);
  }

  setId(id) {
    const { addId } = this.props;
    addId(id);
  }

  setLang(lang) {
    const { addLanguage } = this.props;
    addLanguage(lang);
  }

  setRedirect(bool) {
    this.setState({
      redirectToReferrer: bool,
    });
  }

  handleLoginAfterRegister = (email, password) => {
    onSignIn(email, password)
      .then((res) => {
        if (res) {
          const token = sessionStorage.getItem('USER_TOKEN');
          const base64Url = token.split('.')[1];
          const base64 = base64Url.replace('-', '+').replace('_', '/');
          const tmp = JSON.parse(window.atob(base64));
          const { id } = tmp;
          const lang = tmp.language;
          this.setRedirect(true);
          this.setToken(token);
          this.setId(id);
          this.setLang(lang);
          this.setRedirect(true);
          this.closeLogin();
        }
      })
      .catch((err) => {
        this.setState({
          error: err,
        });
      });
  };

  handleChangeEmail(event) {
    if (
      event.target.value === ''
      || event.target.value === null
      || event.target.value === undefined
    ) {
      this.setState({
        email: event.target.value,
        error_input_email: true,
      });
    } else {
      this.setState({
        email: event.target.value,
        error_input_email: false,
      });
    }
  }

  handleChangePassword(event) {
    if (
      event.target.value === ''
      || event.target.value === null
      || event.target.value === undefined
    ) {
      this.setState({
        password: event.target.value,
        error_input_password: true,
      });
    } else {
      this.setState({
        password: event.target.value,
        error_input_password: false,
      });
    }
  }

  addReset() {
    const { addReset } = this.props;
    addReset(true);
  }

  resetPassword() {
    this.addReset();
  }

  handleSubmit(e) {
    e.preventDefault();

    const { t, app } = this.props;
    const {
      error_input_email,
      error_input_password,
      email,
      password,
    } = this.state;
    const { env } = app;

    if (app.reset) return;

    if (!error_input_email && !error_input_password) {
      this.setState({
        warningError: null,
      });

      onSignIn(email, password, env)
        .then((res) => {
          const { app : { userType } } = this.props;
          if (res) {
            const token = sessionStorage.getItem('USER_TOKEN');
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace('-', '+').replace('_', '/');
            const tmp = JSON.parse(window.atob(base64));
            if (tmp.job === JobList.ADMIN || tmp.job === userType) {
              const { id } = tmp;
              const lang = tmp.language;
              this.setRedirect(true);
              this.setToken(token);
              this.setId(id);
              this.setLang(lang);
              this.closeLogin();
            } else {
              this.setState({
                warningError: t('wrong_type')
              })
            }
          }
        })
        .catch((err) => {
          this.setState({
            error: err,
          });
        });
    } else {
      this.setState({
        warningError: t('everything'),
      });
    }
  }

  closeLogin() {
    const { addLogin, onClose } = this.props;
    onClose();
  }

  addRegister() {
    const { addRegister } = this.props;
    addRegister(true);
  }

  render() {
    const errorMessageLogin = {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '1.2em',
    };

    const { t, location, app: { env }, open } = this.props;
    const { from } = location.state || { from: { pathname: '/' } };
    const {
      redirectToReferrer,
      error_input_email,
      warningError,
      error,
      error_input_password,
    } = this.state;

    // const first = getFirstPage(env);

    // if (redirectToReferrer) {
    //   if (from === null || from.pathname === '/') {
    //     return <Redirect to={`/${env}/${first}`} />;
    //   }
    //   return <Redirect to={from} />;
    // }

    return (
      // dans le cas du modal ??
      <div>
        <Modal
          id="adminImage"
          observeChanges="true"
          size="mini"
          open={open}
          onClose={this.closeLogin}
        >
          <div
            ref={(node) => {
              this.node = node;
            }}
          >
            <Modal.Content>
              <Grid textAlign="center" verticalAlign="middle" padded>
                <Grid.Column id="modalLoginContent">
                  <Image
                    onClick={this.closeLogin}
                    src={Exit}
                    floated="right"
                    id="exit"
                  />
                  <Header as="h2" textAlign="center" id="modalLoginHeader">
                    {t('login_connexion')}
                  </Header>
                  <div class="ui divider" />
                  <Form
                    error={error != null}
                    onSubmit={this.handleSubmit}
                    id="formLogin"
                  >
                    <h4 className="labelstyling">E-MAIL ADDRESS</h4>
                    { error_input_email && warningError ? (
                      <input
                        onChange={this.handleChangeEmail}
                        placeholder={t('placeholder_email')}
                        id="error"
                      />
                    ) : (
                      <input
                        onChange={this.handleChangeEmail}
                        placeholder={t('placeholder_email')}
                      />
                    )}
                    <h4 className="labelstyling">MOT DE PASSE</h4>
                    {error_input_password
                    && warningError ? (
                      <input
                        onChange={this.handleChangePassword}
                        placeholder={t('placeholder_password')}
                        type="password"
                        id="error"
                      />
                      ) : (
                        <input
                          onChange={this.handleChangePassword}
                          placeholder={t('placeholder_password')}
                          type="password"
                        />
                      )}
                    <Grid id="helpLogin">
                      <Grid.Row
                        style={{ marginBottom: '20px' }}
                        equal
                        columns={2}
                      >
                        <Grid.Column>
                          <Form.Checkbox
                            inline
                            defaultChecked
                            label="Se souvenir de moi"
                            className="checkbox"
                          />
                        </Grid.Column>
                        <Grid.Column textAlign="right">
                          <a
                            onClick={this.resetPassword}
                            className="forgotPassword"
                            style={{ cursor: 'pointer' }}
                          >
                            {t('login_forgotpassword')}
                          </a>
                          <br />
                          <ResetPassword />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                    {warningError ? (
                      <Grid.Column style={{ paddingBottom: '15px' }}>
                        <Segment
                          inverted
                          color="red"
                          tertiary
                          style={errorMessageLogin}
                        >
                          <Icon name="remove circle" />
                          {warningError}
                        </Segment>
                      </Grid.Column>
                    ) : (
                      <div />
                    )}
                    <Message
                      error
                      header="Erreur"
                      content="Email ou/et mot de passe invalide."
                    />
                    <Button
                      type="submit"
                      fluid
                      color="yellow"
                      id="connexionButton"
                    >
                      {t('connexion_button')}
                    </Button>
                  </Form>
                  <Header as="h5" className="lightGrey">
                    {t('login_notmember')}{' '}
                    <a
                      onClick={this.addRegister}
                      id="modalLoginLink"
                      style={{ cursor: 'pointer' }}
                    >
                      <u>{t('createaccount')}</u>
                    </a>
                  </Header>
                  <Register login={this.handleLoginAfterRegister} />
                </Grid.Column>
              </Grid>
            </Modal.Content>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

const mapActionToProps = {
  addToken,
  addId,
  addLanguage,
  addLogin,
  addReset,
  addRegister,
};

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapActionToProps
  ),
  translate('LoginComponent')
)(LoginComponent);



// WEBPACK FOOTER //
// ./src/components/Login/LoginComponent.jsx